import { useMemo } from "react";
import { Typography, Grid, useTheme, Theme } from "@mui/material";
import { useSelector } from "react-redux";
import { IRootState } from "src/redux/reducers/CombinedReducers";

interface IColoredBarsProps {
  showName?: boolean;
  statusBar?: boolean;
}

interface IOverrides {
  colorOverride: string;
  barFlash: boolean;
  barName?: string;
}

const barNameStyles = (theme: Theme): object => ({
  marginLeft: "340px",
  fontSize: 16,
  fontWeight: 700,
  color: theme.palette.text.primary,
});

const overrideStyles = (theme: Theme, appBarFlash: boolean, appBarColorOverride?: string): object => ({
  "@keyframes flash": {
    "0%": { backgroundColor: appBarColorOverride ? `#${appBarColorOverride}` : theme.custom.appBar.backgroundColor },
    "50%": { backgroundColor: theme.custom.appBar.backgroundColor },
    "100%": { backgroundColor: appBarColorOverride ? `#${appBarColorOverride}` : theme.custom.appBar.backgroundColor },
  },
  position: "absolute",
  width: "100%",
  height: "100%",
  pointerEvents: "none",
  backgroundColor: appBarColorOverride ? `#${appBarColorOverride}` : theme.custom.appBar.backgroundColor,
  animation: appBarFlash ? "5s linear infinite" : "none",
  animationName: "flash",
});

export const ColoredBackground = (props: IColoredBarsProps): JSX.Element => {
  const { showName, statusBar } = props;
  const theme = useTheme();
  const environment = useSelector(
    (state: IRootState) => state.structures.customerStructure.globalAppConfig.environment
  );

  // Status bar name and color overrides settings.
  const overrides: IOverrides = useMemo(() => {
    return statusBar
      ? {
          colorOverride: environment?.appStatusBarColorOverride,
          barFlash: environment?.appStatusBarFlash ?? false,
          // barName: environment?.name,
        }
      : {
          colorOverride: environment?.appBarColorOverride,
          barFlash: environment?.appBarFlash ?? false,
          barName: environment?.name,
        };
  }, [environment, statusBar]);
  const { colorOverride, barFlash, barName } = overrides;

  // If both override color and name are null, there's no point in displaying bar, return
  if (!colorOverride && !barName) {
    return null;
  }

  return (
    <Grid sx={overrideStyles(theme, barFlash, colorOverride)} container alignItems="center">
      {barName && showName && <Typography sx={barNameStyles(theme)}>{barName}</Typography>}
    </Grid>
  );
};
